import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';

function UploadImageModal({ showUploadModal, handleUploadSubmit, image, childRef, isEditMode }) {
  const { t } = useTranslation('common');

  return (
    <Modal show={showUploadModal} className="common-custom-modal modal-large" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title className="f-24" id="contained-modal-title-vcenter">
            {t('CARE_LABELS.GROUP.UPLOAD_IMAGE.UPLOAD_FILE')}
          </Modal.Title>
          <span onClick={() => handleUploadSubmit('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <ImgDropzone
          ref={childRef}
          onSubmit={handleUploadSubmit}
          image={image}
          acceptedFileExtenstion=".jpeg,.png,.jpg"
          isEditMode={isEditMode}
          title={t('CARE_LABELS.GROUP.UPLOAD_IMAGE.CARE_GROUP')}
        />
      </Modal.Body>
    </Modal>
  );
}

export default UploadImageModal;
